import React, { useEffect } from 'react'
// import { useLocation, useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
// creates a beautiful scrollbar
import PerfectScrollbar from 'perfect-scrollbar'
import 'perfect-scrollbar/css/perfect-scrollbar.css'
import { Sidebar } from '../components/LateralNav/SideBar'
import Navbar from '../components/Header/NavBar'
import styles from '../assets/jss/material-dashboard-react/layout/appStyle'
import { AppRouter } from '../routers/AppSwitch'
import { ROUTESSIDEBAR } from '../routers/RoutesSideBar'
import logo from '../assets/img/logo-bcie-2021-horizontal.webp'
import Spinner from '../components/Spinner/Spinner'
// import Login from './Login/Login'
import { useAuthentication } from '../context/authenticationContext'
import LandingPage from './LandingPage/LandingPage'
import Loading from './Loading/Loading'

let ps
const useStyles = makeStyles(styles)

export const ContainerPages = ({ ...rest }) => {
  const { isAuthenticated, isLoading } = useAuthentication()
  const mainPanel = React.createRef()
  const classes = useStyles()
  const [mobileOpen, setMobileOpen] = React.useState(false)

  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false)
    }
  }
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen)
  }

  useEffect(() => {
    if (isAuthenticated && mainPanel?.current !== null) {
      if (navigator.platform.indexOf('Win') > -1) {
        ps = new PerfectScrollbar(mainPanel.current, {
          suppressScrollX: true,
          suppressScrollY: false,
        })
      }
      window.addEventListener('resize', resizeFunction)
      // Specify how to clean up after this effect:
      return function cleanup() {
        if (navigator.platform.indexOf('Win') > -1) {
          ps.destroy()
        }
        window.removeEventListener('resize', resizeFunction)
      }
    }
  }, [mainPanel])

  if (!isAuthenticated && !isLoading) {
    return <LandingPage />
  } else if (isAuthenticated && !isLoading) {
    return (
      <div className={classes.wrapper}>
        {isAuthenticated && (
          <>
            <Sidebar
              routes={ROUTESSIDEBAR()}
              logoText={'BCIE'}
              logo={logo}
              open={mobileOpen}
              color={'blue'}
              handleDrawerToggle={handleDrawerToggle}
              {...rest}
            />
          </>
        )}
        {isLoading ? (
          <Spinner />
        ) : isAuthenticated ? (
          <>
            <Navbar
              color={'primary'}
              handleDrawerToggle={handleDrawerToggle}
              {...rest}
            />
            <div className={classes.maximMainPanel} ref={mainPanel}>
              <div className={classes.content}>
                <div className={classes.container}>
                  <AppRouter />
                </div>
              </div>
            </div>
          </>
        ) : null}
      </div>
    )
  } else {
    return <Loading />
  }
}
